var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-0 pl-0 pr-4"},[_c('span',{staticClass:"title grey--text"},[_vm._v(_vm._s(_vm.isNew ? _vm.$t("Edit contract") : _vm.$t("Create a new contract")))]),_c(_vm.editSectionComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }